<script setup lang="ts">
useDefaultMeta({
  title: 'COD Cair Cepat | Kirim Paket & Cairkan Hari ini',
  description:
    'Butuh pencairan dana COD cepat? KiriminAja bantu cairkan saldo COD di hari yang sama! Cashflow lancar, bisnismu makin tumbuh.',
  robots: 'index, follow'
})

const faqs = [
  {
    question: 'Berapa lama pencairan dana COD di KiriminAja?',
    answer:
      'Dana COD bisa cair di hari yang sama setelah paket diterima pembeli. Cepat, aman, dan tanpa ribet.'
  },
  {
    question: 'Apakah layanan COD Cair Cepat ini aman?',
    answer:
      'Sangat aman! Semua transaksi dikelola lewat sistem KiriminAja yang terintegrasi dan diawasi secara real-time.'
  },
  {
    question: 'Bisa dipakai di semua ekspedisi?',
    answer:
      'Ya, kamu bisa pakai berbagai ekspedisi favoritmu langsung dari satu dashboard KiriminAja.'
  },
  {
    question: 'Apa bedanya COD Cair Cepat dan COD Advance?',
    answer:
      '<b>COD Cair Cepat</b>: Dana cair setelah paket diterima pembeli.<br /><b>COD Advance</b>: Dana bisa dicairkan bahkan sebelum paket diterima (s&k berlaku).'
  }
]
</script>

<template>
  <div class="flex flex-col">
    <HeroBase
      title="Pengiriman Paket COD, dengan pencairan dana Realtime."
      sub-title="Kirim Paket COD"
      description="Dukungan pengiriman paket COD dengan banyak expedisi dan pencairan Uang COD dihari yang sama ketika paket diterima buyer.! KiriminAja cairkan dana COD tanpa pending — cashflow lancar, bisnis makin cepat berkembang!"
      hero-image="/images/cod-cair-cepat-banner-1.webp"
      button-label="Cairkan Dana COD Sekarang"
      :button-link="
        $utm.utmUrl('/login', {
          redirectTo: '/balance-mutation'
        })
      "
    />

    <KeunggulanCodCairCepatSection1 />
    <KeunggulanCodCairCepatSection2 />
    <KeunggulanCodCairCepatSection3 />
    <KeunggulanCodCairCepatSection4 />
    <FaqBase :faqs="faqs" />
    <KeunggulanCodCairCepatCta />
  </div>
</template>
